import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import SignupBrandPanel from './SignupBrandPanel';
import styles from './LoginEnhanced.module.css';

export default function SignupFinalizationRecovery() {
  const navigate = useNavigate();
  const { user, signOutUser, accountStatus } = useAuth();
  const recovery = useMemo(() => {
    try {
      return JSON.parse(sessionStorage.getItem('signupFinalizationRecovery') || 'null');
    } catch {
      return null;
    }
  }, []);

  const supportReference = recovery?.requestId || user?.uid || 'unavailable';

  const handleSignOut = async () => {
    await signOutUser('signup-finalization-recovery');
    navigate('/signup-access', { replace: true });
  };

  return (
    <div className={styles.splitLayout}>
      <SignupBrandPanel styles={styles} />
      <div className={styles.rightPanel}>
        <div className={styles.formCard}>
          <h2 className={styles.formTitle}>Account Setup Needs Support</h2>
          <p className={styles.formSubtitle}>
            Your authentication session exists, but beta invite finalization has not completed.
          </p>
          <div className={styles.errorMsg}>
            Terminal access unlocks after your account status is active.
          </div>
          <p className={styles.formSubtitle} style={{ fontSize: '0.85rem', opacity: 0.85 }}>
            Status: <strong>{accountStatus || 'pending_invite_finalization'}</strong>
          </p>
          <p className={styles.formSubtitle} style={{ fontSize: '0.85rem', opacity: 0.85 }}>
            Support reference: <strong>{supportReference}</strong>
          </p>
          <div className={styles.sessionActions}>
            <button type="button" className={styles.signInBtn} onClick={() => navigate('/login')}>
              Back to Sign In
            </button>
            <button type="button" className={styles.secondaryActionBtn} onClick={handleSignOut}>
              Restart Signup
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
